import { IConfigsType } from '../../types'

const fwWingstopCorporateIntraday: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/corporate_intraday': {
      variables: ['corporateGroup', 'farwestLocationIntradayConfigs'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'custom',
        ],
        defaultType: 'last_week',
      },
      reportTitle: {
        type: 'title',
        title: 'Hourly Sales',
        subTitle: [
          'Hourly Sales is sourced from Restaurant 365 and may not be available right away.',
          'Please allow some time for the data to sync with Expo.',
        ],
      },
      dayOfWeekSelector: {
        type: 'select',
        value: 'intradayDayOfWeekOptions.value',
        onChange: 'intradayDayOfWeekOptions.onChange',
        options: 'intradayDayOfWeekOptions.options',
        label: 'Day Of Week',
        labelWidth: '110px',
        multiple: true,
        renderValue: `<%- values?.map(v => v.map(vv => vv.displayName).join(" / ")).join(', ') %>`,
      },
      hoursSelector: {
        type: 'select',
        value: 'intradayHoursOptions.value',
        onChange: 'intradayHoursOptions.onChange',
        options: 'intradayHoursOptions.options',
        label: 'Hours',
        labelWidth: '110px',
        multiple: true,
        renderValue: `<%- values?.map(v => v.map(vv => vv.displayName).join(" / ")).join(', ') %>`,
      },
      revenueCenterSelector: {
        type: 'select',
        value: 'intradayRevenueCenterMetricOptions.value',
        onChange: 'intradayRevenueCenterMetricOptions.onChange',
        options: 'intradayRevenueCenterMetricOptions.options',
        label: 'Order Mode',
        labelWidth: '110px',
        width: '400px',
      },

      downloadCsv: {
        type: 'download-csv',
        api: 'fwWingstopLocationIntraday',
        fileName: 'location-intraday-report',
        message: 'Download as CSV',
        fields: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup?.tableColumns) %>',
          },
          {
            key: '<%- JSON(intradayCsvColumns.price) %>',
            hide: '<%- _.isUndefined(intradayCsvColumns.price) %>',
          },
          {
            key: '<%- JSON(intradayCsvColumns.number) %>',
            hide: '<%- _.isUndefined(intradayCsvColumns.number) %>',
          },
        ],
      },

      intradayTable: {
        type: 'table-v2',
        api: 'fwWingstopLocationIntraday',
        pagination: {
          pageSize: 30,
        },
        row: {
          pinning: {
            top: ['summary'],
          },
        },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns.slice(0, 1)) %>',
            hide: '<%- _.isUndefined(corporateGroup?.tableColumns) %>',
            width: '200px',
            sortable: true,
          },
          {
            key: '<%- JSON(intradayTableColumns.price) %>',
            hide: '<%- _.isUndefined(intradayTableColumns.price) %>',
          },
          {
            key: '<%- JSON(intradayTableColumns.number) %>',
            hide: '<%- _.isUndefined(intradayTableColumns.number) %>',
          },
        ],
      },
    },
  },
}

export default fwWingstopCorporateIntraday
